import styled from "@emotion/styled";
import { ArticleItem } from "./News.styles";

export const PhotoGalleryPage = styled.main`
  margin: 50px 0;
`;
export const GalleryRowWrapper = styled.div`
  margin-bottom: 100px;
  .name {
    position: relative;
    display: inline-block;
    font-style: normal;
    font-weight: 700;
    font-size: clamp(26px, 3vw, 34px);
    color: #000000;
    margin-bottom: 50px;
    cursor: pointer;
    //&::before {
    //  content: "";
    //  position: absolute;
    //  bottom: 0;
    //  right: 0;
    //  width: 0;
    //  height: 2px;
    //  background-color: #17479e;
    //  transition: width 0.6s cubic-bezier(0.25, 1, 0.5, 1);
    //}
    //&:hover::before {
    //  left: 0;
    //  right: auto;
    //  width: 100%;
    //}
  }
  ${({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      marginBottom: "60px",
    },
  })}
`;

export const GalleryCardImage = styled.div`
  position: relative;
  width: ${props => props.width + "px"};
  height: ${props => props.height + "px"};
  border-radius: 15px;
  overflow: hidden;
  .overlay {
    background: linear-gradient(
      60.61deg,
      #17479e 11.86%,
      rgba(0, 50, 140, 0.79) 100.15%
    );
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .see {
      font-weight: 500;
      font-size: 22px;
      color: #ffffff;
    }
  }
`;

export const ImagesWrapperSinglePage = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(${({ width }) => width + "px" || "auto"}, 1fr)
  );
  grid-gap: 15px;
  place-items: center;
  ${GalleryCardImage} {
    cursor: pointer;
  }
`;
